/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cta_Add_BoatInputs */

const es_faq_cta_add_boat = /** @type {(inputs: Faq_Cta_Add_BoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir barco`)
};

const gl_faq_cta_add_boat = /** @type {(inputs: Faq_Cta_Add_BoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engadir barco`)
};

const en_faq_cta_add_boat = /** @type {(inputs: Faq_Cta_Add_BoatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add your boat`)
};

/**
* | output |
* | --- |
* | "Add your boat" |
*
* @param {Faq_Cta_Add_BoatInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_cta_add_boat = /** @type {((inputs?: Faq_Cta_Add_BoatInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cta_Add_BoatInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_faq_cta_add_boat(inputs)
	if (locale === "en") return en_faq_cta_add_boat(inputs)
	return es_faq_cta_add_boat(inputs)
});